export const reviews: Array<[string, string, string, string]> = [
  [
    'SP',
    'Sarah P.',
    'Renewable Energy Educator — London, United Kingdom',
    'My students finally understand the difference between solar photovoltaic energy and wind systems. I used to waste hours searching for the right way to explain how they work. Now I enter the classroom fully prepared.',
  ],
  [
    'JM',
    'James M.',
    'Renewable Energy Instructor — Dublin, Ireland',
    'I never arrive unprepared anymore. I know exactly how to explain solar system sizing or how to calculate battery autonomy. This resource does the heavy lifting for me.',
  ],
  [
    'EM',
    'Emma M.',
    'Energy Technology Teacher — Amsterdam, Netherlands',
    'The lesson planning saves me countless hours. The integrated projects are organized step-by-step. I never improvise in front of my students anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'SP',
    'Sarah P.',
    'Renewable Energy Educator | London, United Kingdom',
    "The material on solar systems and sizing completely changed my students' understanding. They finally grasp how to actually calculate an installation. It's the clearest resource I've found on this topic. I use it from day one and it captures their attention immediately.",
  ],
  [
    'JM',
    'James M.',
    'Renewable Energy Instructor | Dublin, Ireland',
    'The 150 activities alone are worth the price. I never improvise a lesson anymore. I finish every quarter knowing everything is prepared and ready.',
  ],
  [
    'DG',
    'David G.',
    'Energy Technology Teacher | Berlin, Germany',
    "The 100 solved problems transformed students who struggled with power and autonomy calculations. Now they see step-by-step how to solve them and apply it themselves. I haven't found this quality in any other resource.",
  ],
  [
    'AM',
    'Anna M.',
    'University Lecturer | Brussels, Belgium',
    'The visual component guide gave me back my class time. I used to spend twenty minutes explaining how an inverter works. Now I show the guide and students instantly understand.',
  ],
  [
    'SR',
    'Stefan R.',
    'Renewable Energy Instructor | Copenhagen, Denmark',
    "The 50 integrated projects were eye-opening. My students finally understand why all this matters. They're designing renewable systems in their own communities. This completely transformed how they see renewable energy.",
  ],
];
